import {Modal, Col, Row, Form} from 'react-bootstrap';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import {FormInput} from '../../formElements/FormInput';
import CommonService from '../../../services/CommonService';
import BaseService from '../../../services/BaseService';
import { Typeahead } from 'react-bootstrap-typeahead';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {FaCalendarAlt} from 'react-icons/fa';

const EditProposedDebt = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, proposedDebtInfo, finalSaleId} = props;
    const [formErrors, setFormErrors] = useState({});
    const [proposeDebt, setProposeDebt] = useState({...proposedDebtInfo});
    const [hasFinalSale, setHasFinalSale] = useState(false);
    
    const proposedDebtStatus = [
        {
            statusFlag: "C",
            statusName: "Cancelled"
        },
        {
            statusFlag: "D",
            statusName: "Draft"
        },
        {
            statusFlag: "E",
            statusName: "Edited - Resubmitted"
        },
        {
            statusFlag: "P",
            statusName: "Proposed"
        },
        {
            statusFlag: "R",
            statusName: "Reviewed"
        },
    ]

    const handleDateChange = (e, key) => {
        setProposeDebt(prevState=>({
            ...prevState, 
            [key]: e??''
        })
        )
    }

    const handleTypeaheadChange = (e, key) => {
        let selectedValue = '';
        if(key === 'issueStatusFlag') {
            selectedValue = e.length > 0 ? e[0]['statusFlag'] : "";
            if(selectedValue !== 'R'){
                setHasFinalSale(finalSaleId === null ? false : true) ;
            }
            else {
                setHasFinalSale(false) ;
            }
        }
        setProposeDebt(prevState=>({
            ...prevState, 
            [key]: selectedValue
        })
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-proposed');
        let formErrors = validateFormFields(form.elements);
        
        if(Object.keys(formErrors).length > 0 || hasFinalSale) {
            setFormErrors(formErrors);
        } else {  
            setFormErrors({});
            var obj = {
                msgId: null,
                sysId: null,
                opr: "putProposedDebtUpdate",
                hdrStruct: null,
                queryParam: null,
                reqData: { 
                    "proposeDebt" : {
                        "cdiacNbr": proposeDebt.cdiacNbr,
                        "proposeDebtId": proposeDebt.proposeDebtId,
                        "issuerName": proposeDebt.issuerName,
                        "projectName": proposeDebt.projectName,
                        "issueStatusFlag": proposeDebt.issueStatusFlag,
                        "proposedSaleDate": proposeDebt.proposedSaleDate,
                        "principalSaleAmt": proposeDebt.principalSaleAmt,
                        "filingDate": proposeDebt.filingDate,
                        "lastUpdateUser": CommonService.getUserName(user)
                    }
                },
            };
        
            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0){
                            toast.error(result.data.errors[0].message)
                    }
                    else{
                        toast.success("Proposed Debt updated successfully!");
                        onModalClose();
                    }

                });
        }
    }
    
    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit Report of Proposed Debt Issuance</h3></Modal.Header>
            <Modal.Body>
            <Form id="edit-proposed">
                <div className="contactForm">
                    <Row>
                            <Col md={4} className="control">
                                <FormInput
                                    label="CDIAC#"
                                    type="text"
                                    value={proposeDebt.cdiacNbr}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={8} className="control">
                                 <FormInput
                                    label="Issuer Name"
                                    type="text"
                                    value={proposeDebt.issuerName}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="control">
                                 <FormInput
                                    label="Project Name"
                                    type="text"
                                    value={proposeDebt.projectName}
                                    disabled
                                    readOnly
                                />
                            </Col>
                             <Col md={6} className="control">
                                <FormInput
                                    label="Principal Sale Amount"
                                    type="text"
                                    value={CommonService.currencyFormatter(proposeDebt.principalSaleAmt)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                     <Row>
                            <Col md={6} className="control">
                                    <label><span className="required">*</span>Proposed Debt Status: </label>
                                    <Typeahead
                                        placeholder="Choose a Proposed Debt Status"
                                        id="issueStatusFlag"
                                        name="issueStatusFlag"
                                        labelKey="statusName"
                                        onChange={e => handleTypeaheadChange(e, 'issueStatusFlag')}
                                        inputProps={{ 'data-validations': 'required', name: 'issueStatusFlag' }}
                                        options={proposedDebtStatus}
                                        selected={
                                            proposedDebtStatus.filter(option =>
                                                option.statusFlag === proposeDebt.issueStatusFlag)
                                        }
                                    />
                                {formErrors.issueStatusFlag && <p className="error">Proposed Debt Status is required</p>}
                                {hasFinalSale && <p className="error">Proposed Debt has Final Sale, Status change not allowed</p>}
                            </Col>
                             <Col md={6} className="control">
                                    <label><span className="required">* </span>Proposed Debt Sale Date: </label>
                                    <div>
                                        <span>
                                            <DatePicker
                                                selected={proposeDebt.proposedSaleDate ? new Date(proposeDebt.proposedSaleDate) : null}
                                                dateFormat="M/d/yyyy"
                                                maxDate={new Date(9999, 12, 31)}
                                                name="proposedSaleDate1"
                                                onChange={(e) => handleDateChange(e, 'proposedSaleDate')}
                                            />
                                            <FaCalendarAlt className="date-picker-icon" />
                                        </span>
                                        {formErrors.proposedSaleDate && <p className="error">Proposed Debt Sale Date is required</p>}
                                        <input type="hidden" data-validations={["required"]} value={proposeDebt.proposedSaleDate} name="proposedSaleDate" />
                                    </div>
                            </Col>
                    </Row> 
                    <Row>
                            <Col md={6} className="control">
                                    <label><span className="required">* </span>Proposed Debt Filing Date: </label>
                                    <div>
                                        <span>
                                            <DatePicker
                                                selected={proposeDebt.filingDate ? new Date(proposeDebt.filingDate) : null}
                                                dateFormat="M/d/yyyy"
                                                maxDate={new Date(9999, 12, 31)}
                                                name="filingDate1"
                                                onChange={(e) => handleDateChange(e, 'filingDate')}
                                            />
                                            <FaCalendarAlt className="date-picker-icon" />
                                        </span>
                                        {formErrors.filingDate && <p className="error">Proposed Debt Filing Date is required</p>}
                                        <input type="hidden" data-validations={["required"]} value={proposeDebt.filingDate} name="filingDate" />
                                    </div>
                            </Col>
                    </Row>
                </div>
                <div className="btn-div">
                <div className="fright">
                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                    <button className="custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Update Proposed Debt</button>
                    </div>
                </div>
            </Form>                
            </Modal.Body>
        </Modal>
    )
}

export default EditProposedDebt
